module.exports = __webpack_public_path__ + "img/SubirVerifactuIcon.29f18fc2.svg";